import { useRef, useState, useEffect } from "react";
import "./Servicessection.css";

const svcData = [
  {
    title: "Web Development",
    desc: "Responsive, fast and SEO-ready websites built with modern stacks.",
    accent: "orange",
    icon: (
      <svg viewBox="0 0 40 40" fill="none">
        <rect x="4" y="8" width="32" height="22" rx="3" stroke="currentColor" strokeWidth="2"/>
        <path d="M14 34h12M20 30v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M11 18l5 5 9-9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: "Mobile App Dev",
    desc: "Cross-platform iOS & Android apps with smooth native-like UX.",
    accent: "blue",
    icon: (
      <svg viewBox="0 0 40 40" fill="none">
        <rect x="12" y="4" width="16" height="32" rx="4" stroke="currentColor" strokeWidth="2"/>
        <circle cx="20" cy="30" r="1.5" fill="currentColor"/>
        <path d="M17 10h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    title: "Custom Software",
    desc: "Bespoke enterprise software solving real business problems end-to-end.",
    accent: "orange",
    icon: (
      <svg viewBox="0 0 40 40" fill="none">
        <path d="M10 12l-6 6 6 6M30 12l6 6-6 6M22 8l-4 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: "Cloud Computing",
    desc: "Scalable cloud infrastructure, DevOps pipelines and managed services.",
    accent: "blue",
    icon: (
      <svg viewBox="0 0 40 40" fill="none">
        <path d="M10 28a8 8 0 010-16 10 10 0 0119.2 4A6 6 0 0130 28" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
        <path d="M20 32v-10M17 25l3-3 3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    title: "UI/UX Designing",
    desc: "Pixel-perfect interfaces that delight users and drive conversions.",
    accent: "orange",
    icon: (
      <svg viewBox="0 0 40 40" fill="none">
        <circle cx="20" cy="20" r="14" stroke="currentColor" strokeWidth="2"/>
        <circle cx="20" cy="20" r="5" stroke="currentColor" strokeWidth="2"/>
        <path d="M20 6v4M20 30v4M6 20h4M30 20h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
  },
  {
    title: "Digital Marketing",
    desc: "SEO, social media & performance campaigns that grow your brand online.",
    accent: "blue",
    icon: (
      <svg viewBox="0 0 40 40" fill="none">
        <path d="M8 28l6-8 6 4 6-10 6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <rect x="4" y="4" width="32" height="32" rx="4" stroke="currentColor" strokeWidth="2"/>
      </svg>
    ),
  },
];

function useInView(threshold = 0.1) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) { setInView(true); obs.disconnect(); } },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

export default function ServicesSection() {
  const [secRef, inView] = useInView(0.08);

  return (
    <section className="ss-section" id="services" ref={secRef}>
      <div className="ss-container">

        {/* Header */}
        <div className={`ss-header${inView ? " ss-header--in" : ""}`}>
          <span className="ss-eyebrow">What We Offer</span>
          <h2 className="ss-heading">Our Services</h2>
          <p className="ss-sub">
            End-to-end technology and growth solutions, built and supported
            by the SkillSync Pro team from strategy to launch.
          </p>
        </div>

        {/* Cards grid */}
        <div className="ss-grid">
          {svcData.map((s, i) => (
            <div
              key={s.title}
              className={`ss-card ss-card--${s.accent}${inView ? " ss-card--in" : ""}`}
              style={{ transitionDelay: `${0.05 + i * 0.07}s` }}
            >
              <div className="ss-card__icon">{s.icon}</div>
              <h3 className="ss-card__title">{s.title}</h3>
              <p className="ss-card__desc">{s.desc}</p>
              <a href="/services" className="ss-card__link">
                Learn More <span className="ss-card__arrow">&rarr;</span>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}